module.exports = __webpack_public_path__ + "images/website.cc02dbbd8b13bde2a992a89a519149e4.jpg";